import AxiosClient from "../../../../services/axios.services";

class BienvenidaServices {
  getBienvenida = (params) =>
    AxiosClient.get("/api/app/On_off_boarding_bienvenida/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getBienvenidaPorUsuario = (data) =>
    AxiosClient.get("/api/app/On_off_bording_bienvenida_embebida/", {
      headers: { "Content-Type": "application/json" },
      params: data,
    });

  saveBienvenida = (data) =>
    AxiosClient.post("/api/app/On_off_boarding_bienvenida/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editBienvenida = (id, data) =>
    AxiosClient.put(`/api/app/On_off_boarding_bienvenida/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteBienvenida = (id) =>
    AxiosClient.delete(`/api/app/On_off_boarding_bienvenida/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new BienvenidaServices();
